import React from 'react';
import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import List from './DefaultList/List';

const ListPicker = ({ collection }) => {
  const { pageContentResource } = usePageContentContext();
  return pick(pageContentResource, { }, <List collection={collection} />);
};

ListPicker.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};
ListPicker.defaultProps = {};

export default ListPicker;
